export default __webpack_public_path__ + "c7816c0592e176720dd1f684c05c9e06.svg";